/* Component Dependencies */
var AriesComponent = require('libs/aries-component');
var aaaMemberFormTemplate = require('templates/aaaMemberForm.hbs');
var Popup = require('libs/popup');
var PubSub = require('libs/pub-sub');
var autoFormat = require('reservation_libs/auto-format');

AriesComponent.create({
	type: 'aaaMemberForm',
	template: {
		'aaaMemberForm': aaaMemberFormTemplate
	},
	events: {
		'click .submit-member-form': 'submitHandler',
		'keypress .t-member-form-input': 'numberOnlyChar',
		'paste .t-member-form-input': 'numberOnlyField',
		'click .js-select-another-rate': 'associateAnotherRateHandler',
		'input .t-member-form-input': 'checkAndEnableSubmitBtn',
	},
	submitHandler: function() {
		'use strict';
		var _self = this,
			form = _self.$el.find('#memberForm'),
			input = _self.$el.find('input[name="aaaNumber"]'),
			submitButton = _self.$el.find('.submit-member-form'),
			roomRatesSelectionForm = $('body').find('#roomRatesSelectionForm'),
			isModifyFlow = window.localStorage.getItem('isModifyFlow'),
			data = {
				aaaNumber: input.val()
			},
			isAssociate = _self.$el.data('isAssociate'),
			isBookingCartFlow = _self.$el.data('bookingCartFlow');

		submitButton.addClass('is-global-disable');
		$('.tile-aaa-member-form').addClass('aaa-ajax-loader');
		$('.member-container').addClass('aaa-apply-opacity');
		// Ajax Post call to submit aaa number and get the respective response
		_self.makeAjaxCall({
			method: 'POST',
			url: form.attr('action'),
			data: JSON.stringify(data),
			contentType: 'application/json',
			success: function(res) {
				if(res.showError){
					$('.m-message-box-error').show();
					input.addClass('is-error');
					$('.tile-aaa-member-form').removeClass('aaa-ajax-loader');
					$('.member-container').removeClass('aaa-apply-opacity');
				}else{
					if (input.hasClass('is-error')) {
						$('.m-message-box-error').hide();
						input.removeClass('is-error');
					}
					if (isAssociate) {
						if (isBookingCartFlow) {
							_self.pubsub.publish('SUBMIT_BOOKING_CART_FORM', [res]);
						} else {
							roomRatesSelectionForm.submit();
						}
					} else {
						if (isModifyFlow === 'false'){
							roomRatesSelectionForm.submit();
						} else{
							_self.submitFormData(roomRatesSelectionForm);
						}
					}
				}
			}
		});
		return true;
	},

	submitFormData: function(roomRatesSelectionForm){
		var _self = this;
		_self.makeAjaxCall({
			url: roomRatesSelectionForm.attr('action'),
			contentType: 'application/x-www-form-urlencoded',
			method: 'POST',
			data: roomRatesSelectionForm.serialize(),
			skipRedirect: true,
			success: function(response) {
				_self.summaryOfChargesHandler(response.nextStateURI);
			}
		});
	},

	summaryOfChargesHandler: function (url) {
		var summaryOfCharges = new Popup({
			url: url,
			selector: '.mi-popover',
			open: true,
			alternateCloseMarkup: true,
			sourceBlock: '.modal-content',
			mainClass: 'm-modal t-modal-med'
		});
		summaryOfCharges.register();
	},

	numberOnlyChar : function(event){
		var ch = String.fromCharCode(event.which);
		if(!(/[0-9]/.test(ch))){
			event.preventDefault();
		}
		var _self = this;
		_self.aaaNumberAutoFormat();
	},

	numberOnlyField : function(event){
		var clipBoardText = event.clipboardData || event.originalEvent.clipboardData || window.clipboardData;
		var pastedText = clipBoardText.getData('text'),
						trimmedText;
		if (/^[0-9]+$/.test(pastedText) === false) {
				event.preventDefault();
				trimmedText = pastedText.replace(/[^0-9]/g, '');   // strip all non-numeric chars
				trimmedText = trimmedText.substr(0, 16);           // truncate to max 16 characters
				event.target.value = trimmedText;
		}
		event.target.value = pastedText;
		var _self = this;
		_self.aaaNumberAutoFormat();
		var aaaNumber = this.$el.find('input[name="aaaNumber"]').val();
 	_self.enableDisableSubmitCTA(aaaNumber);
	},

	aaaNumberAutoFormat: function _aaaNumberAutoFormat(){
		var _self = this;
		var target = this.$el.find('input[name="aaaNumber"]');
 	target.mask('999 999 999999999 9');
		target.unmask();
	},

 	associateAnotherRateHandler: function _associateAnotherRateHandler (event) {
		var _self = this;
		var selectAnotherRateURL = _self.$el.find('.js-select-another-rate').attr('href');
		
		if(selectAnotherRateURL === '#') {
			event.preventDefault();
			_self.pubsub.publish('POPUP_CLOSE');
		}
	 },
	 checkAndEnableSubmitBtn: function _checkAndEnableSubmitBtn(event) {
	 	var _self = this;
				_self.enableDisableSubmitCTA(event.target.value);
	 },

	 enableDisableSubmitCTA: function _enableDisableSubmitCTA(givenNumber) {
  				if(givenNumber != null && givenNumber.length === 19) {
  					$(".js-aaa-submit").attr('disabled', false).removeClass('is-disabled');
  				} else {
  					$(".js-aaa-submit").attr('disabled', true).addClass('is-disabled');
  				}
  	 }
});
